import { Component, ViewChild, AfterViewInit, inject, ChangeDetectorRef } from '@angular/core';
import { tableModel } from '../../../components/table/model/tableModel';
import { TableComponent } from '../../../components/table/table.component';
import { User } from '../../../models/user';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { FilterUser } from '../../../models/filters/filter-user';
import { MatExpansionPanel } from '@angular/material/expansion';
import { AlertaService } from '../../../services/alerta.service';

@Component({
  selector: 'app-user',
  standalone: false,
  templateUrl: './user.component.html',
  styleUrl: './user.component.css'
})
export class UserComponent implements AfterViewInit{
  users: User[] = [];

  @ViewChild(TableComponent) userTable:TableComponent | undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;
  
  tableModel: tableModel= {
    columnModel:[{columnName:'No.',columnValue:'id'},
      {columnName:'Nombre',columnValue:'fullName'},
      {columnName:'Correo',columnValue:'email'}],
    dataSource:[],
    editButton:true
  };
  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterUser: FilterUser = new FilterUser;
  advancedSearch: boolean = false;

  private userService = inject(UserService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
    private alerta = inject(AlertaService);

  ngAfterViewInit() {
 
  }

  ngOnInit(): void {
    this.filterUser = new FilterUser();
    this.filterUser.ac = 1;
    this.searchUsersPaginator();
  }

  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchUsersPaginator();
  }

  editEvent(event: any){
    this.router.navigate(['/users/edit', event.id]);
  }
  searchUsersPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchUsersPaginator();
  }

  searchUsersPaginator(){
    this.loading = true;

    this.userService.findAllPageableUser(this.filterUser, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.userTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }
}
